import React from 'react';

interface AuthModalProps {
  isOpen: boolean;
}

const AuthLoadingFullscreen: React.FC<AuthModalProps> = ({ isOpen }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <div className="text-center text-slate-700">
        <div className="text-2xl font-medium tracking-wide">
          Loading
          <span className="loading-dots">...</span>
        </div>
      </div>
    </div>
  );
};

export default AuthLoadingFullscreen;
